let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5;
import styled, { css } from 'styled-components';
import { colors } from '@ovpn-ui/styles';
import { fontStack, fontWeights } from '../../styles';
const selectContainerStateStyles = ({
  success,
  error,
  warning
}) => {
  if (success) {
    return css(_t || (_t = _`
            p,
            .ovpn-input-description-icon {
                color: ${0};
            }
        `), colors.successBaseHover);
  }
  if (error) {
    return css(_t2 || (_t2 = _`
            p,
            .ovpn-input-description-icon {
                color: ${0};
            }
        `), colors.warningBaseHover);
  }
  if (warning) {
    return css(_t3 || (_t3 = _`
            p {
                color: ${0};
            }
            .ovpn-input-description-icon {
                color: ${0};
            }
        `), colors.neutralTextBody, colors.attentionBaseHover);
  }
  return '';
};
export const DescriptionContainer = styled.div.attrs({
  className: 'ovpn-form-field-description'
})(_t4 || (_t4 = _`
    display: flex;
    gap: 8px;
    align-items: center;

    margin-top: 8px;

    ${0}
`), selectContainerStateStyles);
export const Description = styled.p(_t5 || (_t5 = _`
    display: inline;

    color: ${0};
    font-weight: ${0};
    ${0}
`), colors.neutralTextSubtitle, fontWeights.regular, fontStack.textSm);